import { HStack } from "@chakra-ui/react";
import { ColorModeSwitcher } from "./ColorModeSwitcher";

type Props = {
  tooltipVariantion?: string;
};

export const IconNav = ({ tooltipVariantion }: Props) => {
  return (
    <HStack>
      <ColorModeSwitcher tooltipVariantion={tooltipVariantion} />
    </HStack>
  );
};
